<div class="container">
  <div class="select-file-group">
    <button
      class="select-file-button"
      type="button"
      mat-stroked-button
      (click)="assetFilesUploadInput.click()"
      color="accent"
      [disabled]="uploading"
    >
      Select Files
    </button>
    <input
      hidden
      (change)="onFilesSelected()"
      #assetFilesUploadInput
      type="file"
      multiple
      id="sku-file-upload-input"
    />

    <span
      *ngIf="selectedFile"
      class="selected-file"
    >
      <span class="file-name">{{ selectedFile?.name }} </span>
      <div>
        <span class="file-size">({{ selectedFile?.size | fileSize }}) </span>
      </div>
    </span>
  </div>
  <div class="upload-file-group">
    <button
      class="upload-file-button"
      type="button"
      mat-stroked-button
      (click)="uploadAssetFiles()"
      color="accent"
      [disabled]="!selectedFile || uploading"
    >
      Upload Files
    </button>

    <span
      class="spinner"
      *ngIf="uploading"
    >
      <mat-progress-spinner
        color="accent"
        [mode]="spinnerMode"
        [value]="spinnerValue"
        strokeWidth="5"
        diameter="25"
      >
      </mat-progress-spinner>
    </span>
    <span
      class="upload-status"
      *ngIf="uploading"
      >{{ uploadStatus }}</span
    >
  </div>
  <div
    class="upload-responses-group"
    *ngIf="uploadResponses.length"
  >
    <div class="title">Activity Log</div>
    <div
      class="upload-response"
      *ngFor="let uploadResponse of uploadResponses; index as idx"
    >
      <div class="upload-response-basic-container">
        <div class="timestamp">{{ uploadResponse.timestamp | date: "mediumTime" }}</div>
        <div class="total-files">Total Files: {{ uploadResponse.totalFiles }}</div>
        <div class="total-size">Total Size: {{ uploadResponse.totalSize | fileSize }}</div>
      </div>
      <div
        class="successful-files"
        *ngIf="uploadResponse.successfulFiles?.length"
      >
        <div class="files-header">Successful Files: {{ uploadResponse.successfulFiles.length }} / {{ uploadResponse.totalFiles }}</div>
        <div class="files-content">
          <div
            class="file successful-file"
            *ngFor="let file of uploadResponse.successfulFiles"
          >
            {{ file }}
          </div>
        </div>
      </div>
      <div
        class="error-files"
        *ngIf="uploadResponse.fileErrors?.length || uploadResponse.error"
      >
        <div
          class="error-message"
          *ngIf="uploadResponse.error"
        >
          Error Message: {{ uploadResponse.error }}
        </div>
        <ng-container *ngIf="uploadResponse.fileErrors?.length">
          <div class="files-header">Error Files: {{ uploadResponse.fileErrors.length }} / {{ uploadResponse.totalFiles }}</div>
          <div class="files-content">
            <div
              class="file error-file"
              *ngFor="let fileError of uploadResponse.fileErrors"
            >
              <div class="file-name">{{ fileError.fileName }}</div>
              <div class="error">{{ fileError.error }}</div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
